import { SimulationsListRequestInterface } from '../../../../interfaces/request/simulator/simulations-list/simulations-list-request-interface';

export class SimulationsListRequestModel implements SimulationsListRequestInterface {
  Name: string = '';
  Product: string = '';
  SimulationDateEnd: string = '';
  SimulationDateStart: string = '';
  TaxNumber: string = '';
  page: number | undefined;
  pageSize: number | undefined;

  constructor(init?: Partial<SimulationsListRequestModel>) {
    Object.assign(this, init);
  }
}
